import type { AppDetailsSchema } from '~/types/product.model'

export const useAppDetailsPageSchema = (app: AppDetailsSchema | null): void => {
  useHead(() => ({
    script: [
      {
        type: 'application/ld+json',
        innerHTML: {
          '@context': 'https://schema.org',
          '@type': 'SoftwareApplication',
          'name': app?.title || 'App in Sendcloud App Store',
          'description': app?.short_description,
          'image': app?.logo_url,
          'author': {
            '@type': 'Organization',
            'name': app?.developer.name,
          },
          'applicationCategory': app?.category.title,
          ...(app?.rating_stats && {
            aggregateRating: {
              '@type': 'AggregateRating',
              'ratingValue': app.rating_stats.average_rating,
              'ratingCount': app.rating_stats.number_of_ratings,
            },
          }),
        },
      },
    ],
  }))
}
